<template>
  <TwoColumnQuizReviewLayout>
    <template #responses>
      <ResponseItem
        v-for="(option) in responses"
        :key="option.id"
        :option="option"
        :showCheckMarkIcon="false"
      />
    </template>
    <template v-if="answers?.length > 0" #answers>
      <ResponseItem
        v-for="(option) in answers"
        :key="option.id"
        :option="option"
        :showCheckMarkIcon="false"
      />
    </template>
  </TwoColumnQuizReviewLayout>
</template>
<script>

import TwoColumnQuizReviewLayout from '@/components-v2/presentation-report/ReportAudienceDetail/closed-question/TwoColumnQuizReviewLayout.vue'
import ResponseItem from '@/components-v2/presentation-report/ReportAudienceDetail/closed-question/ResponseItem.vue'

export default {
  components: {
    TwoColumnQuizReviewLayout,
    ResponseItem,
  },
  props: {
    report: {
      type: Object,
      default: () => {
      },
    },
  },
  computed: {
    answers() {
      return this.report?.answers?.map((a) => {
        return {
          title: a.title,
          image: a.image,
        }
      })
    },
    responses() {
      return this.report?.response?.submissions?.map((a) => {
        return {
          title: a.text,
          image: a.image,
        }
      })
    },
  },
}
</script>
